var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9872 21.5127L19.5449 17.0704C20.4627 15.687 21 14.0306 21 12.25C21 7.42525 17.0747 3.5 12.25 3.5C7.42525 3.5 3.5 7.42525 3.5 12.25C3.5 17.0747 7.42525 21 12.25 21C14.0306 21 15.687 20.4627 17.0704 19.5449L21.5127 23.9872C22.1952 24.6706 23.3047 24.6706 23.9872 23.9872C24.6706 23.3039 24.6706 22.1961 23.9872 21.5127ZM6.125 12.25C6.125 8.8725 8.8725 6.125 12.25 6.125C15.6275 6.125 18.375 8.8725 18.375 12.25C18.375 15.6275 15.6275 18.375 12.25 18.375C8.8725 18.375 6.125 15.6275 6.125 12.25Z",
    fill: "#F1B964"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bcbf0fd035aed7899d880f14830e0806.svg";
export { ForwardRef as ReactComponent };